import React from 'react'
import PropTypes from 'prop-types'
import { TwoColumnBanner as BannerTwoColumnComponent } from '@ampdx/component-library/dist/components/index'

const BannerTwoColumn = props => {
  return <BannerTwoColumnComponent content={{ ...props.content }} />
}

BannerTwoColumn.propTypes = {
  content: PropTypes.object,
}

export default BannerTwoColumn
